<template>
  <div class="radius-app">
    <component :is="layout">
      <router-view :layout.sync="layout" />
    </component>
  </div>
</template>

<script>
import AuthLayout from "@/layouts/auth.vue";
import AppLayout from "@/layouts/app.vue";
import ProductLayout from "@/layouts/product.vue";
import AuthxAppLayout from "@/layouts/authx-app.vue";
import DefaultLayout from "@/layouts/default.vue";

export default {
  name: "App",
  components: {
    AuthLayout,
    AppLayout,
    ProductLayout,
    AuthxAppLayout,
    DefaultLayout
  },
  data() {
    return {};
  },
  computed: {
    layout() {
      return `${this.$route.meta.layout || "default"}-layout`;
    }
  }
};
</script>

<style lang="scss">
.radius-app {
  position: relative;
  min-height: 100vh;
  background: #fff;
}

.vue-notifyjs .alert[data-notify="container"] {
  z-index: 9999;
  width: 30% !important;
}

.vue-notifyjs .alert span {
  margin: 6px 0 6px;
}
</style>
